import { CircleHelp, Search, UserPlus, Users } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { useEmail } from '@/components/providers/EmailProvider/EmailProvider';
import { useModal } from '@/components/providers/ModalProvider/ModalProvider';
import { Button } from '@/components/shadcn/button';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/shadcn/tooltip';
import useAuth from '@/hooks/useAuth';

import useCreateParty from '../../mutations/useCreateNaturalParty';
import CreatePartyModal from '../CreatePartyModal/CreatePartyModal';

import PartySearchModal from './PartySearchModal';

export default function SearchParty() {
  const { t } = useTranslation();

  const { showModal } = useModal();

  const { linkParty, email } = useEmail();
  const { broker } = useAuth();

  const { mutateAsync: createParty } = useCreateParty();

  const colleagueDomain = broker?.email?.split('@')[1] ?? '';

  const handleShowPartySearch = () =>
    showModal(
      PartySearchModal,
      {
        onSubmit: linkParty,
      },
      {
        title: t('SIDEBAR_PARTY_SEARCH'),
        size: 'full',
      },
    );

  const handleShowCreateParty = () =>
    showModal(
      CreatePartyModal,
      { onSubmit: createParty },
      { title: t('CREATE_PARTY_MODAL_TITLE') },
    );

  return (
    <div className="flex flex-col gap-3">
      <div className="flex h-7 items-center justify-between">
        <div className="text-foreground flex items-center gap-1.5 text-sm">
          <Users className="size-3.5" />

          {t('PARTY_SEARCH_TITLE')}
        </div>
      </div>

      <div className="flex flex-col gap-2">
        <p className="text-muted-foreground text-xs">
          {t('PARTY_NO_CLIENT_IDENTIFIED')}
          <Tooltip>
            <TooltipTrigger asChild>
              <CircleHelp className="ml-1 inline size-3.5 cursor-help" />
            </TooltipTrigger>

            <TooltipContent side="bottom" className="max-w-xs">
              {t('PARTY_NO_CLIENT_IDENTIFIED_TOOLTIP', {
                domain: colleagueDomain,
              })}

              {email?.allAddresses && email?.allAddresses.length > 0 && (
                <ul className="mt-1 list-inside list-disc">
                  {email?.allAddresses?.map((address) => (
                    <li key={address}>{address}</li>
                  ))}
                </ul>
              )}
            </TooltipContent>
          </Tooltip>
        </p>

        <div className="flex w-full gap-1">
          <Button size="sm" className="grow" onClick={handleShowCreateParty}>
            <UserPlus />

            {t('PARTY_CREATE_BUTTON')}
          </Button>

          <Button
            variant="secondary"
            size="sm"
            className="grow"
            onClick={handleShowPartySearch}
          >
            <Search />
            {t('PARTY_SEARCH_SECONDARY_BUTTON')}
          </Button>
        </div>
      </div>
    </div>
  );
}
